<script>
import { mapActions } from "vuex";
import InfiniteAutocomplete from "./InfiniteAutocomplete.vue";

/**
 * 排出事業者・事業場選択コンポーネント
 *
 */
export default {
  name: "InfiniteTransportRouteAutoComplete",
  components: {
    InfiniteAutocomplete,
  },
  props: {
    /**
     * 運搬ルートID
     */
    transportRouteId: {
      type: Number,
      default: () => null,
    },
    /**
     * 排出事業者 非活性化
     */
    transportRouteDisabled: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: "",
    },
    /**
     * 非表示を除く
     */
    withoutInvisible: {
      type: Boolean,
      default: true,
    },
    /**
     * 区間1の収運が自社
     */
    firstTraderOwned: {
      type: Boolean,
      default: false,
    },
    /**
     * 排出自己運搬(排出持込)
     */
    selfEmission: {
      type: Boolean,
      default: false,
    },
    /**
     * 他社区間代行起票
     */
    proxyRequest: {
      type: Boolean,
      default: false,
    },
    /**
     * 一般廃棄物
     */
    general: {
      type: Boolean,
      default: false,
    },
    /**
     * 処分業者が報告不要以外
     */
    withoutNonReporting: {
      type: Boolean,
      default: false,
    },
    /**
     * 排出自己運搬を除く
     */
    withoutSelfEmission: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      transportRouteLoading: false,
      transportRouteSearchKeyword: null,
      transportRouteTimerId: undefined,
      transportRoutePageNumber: 0,
      transportRoutes: [],
      transportRoutePagination: {
        next_page: null,
        prev_page: null,
        is_first_page: false,
        is_last_page: false,
      },
      workableId: null,
    };
  },
  computed: {},
  watch: {
    /**
     * 排出事業者IDの変更検知
     * @param newValue 排出事業者ID
     * @param oldValue
     */
    transportRouteId(newValue, oldValue) {
      this.workableId = newValue;
      if (newValue !== oldValue) {
        this.loadTransportRoute();
      }
    },
    /**
     * 作業用排出事業場IDの変更検知
     */
    workableId() {
      this.returnCurrentValues();
    },
  },
  created() {
    if (this.transportRouteId) {
      this.workableId = this.transportRouteId;
      this.loadTransportRoute();
    } else {
      this.fetchTransportRouteMembers();
    }
  },
  methods: {
    ...mapActions("DriverMasterSearchMembersTransportRoute", {
      fetchTransportRoutes: "index",
    }),
    loadTransportRoute() {
      const conditions = {
        query: null,
        target_id: this.workableId,
        without_invisible: this.withoutInvisible,
        first_trader_owned: this.firstTraderOwned,
        self_emission: this.selfEmission,
        proxy_request: this.proxyRequest,
        general: this.general,
        without_non_reporting: this.withoutNonReporting,
        without_self_emission: this.withoutSelfEmission,
        enable_pagination: true,
      };
      this.fetchTransportRoutes({
        conditions: conditions,
        page: 1,
      }).then((response) => {
        this.transportRoutes = response.transport_routes;
        this.transportRoutePagination = response.pagination;
        this.transportRoutePageNumber = response.pagination.current_page;
      });
    },

    /**
     * 排出事業者のリロード処理
     */
    reloadTransportRoutes() {
      this.transportRouteSearchKeyword = null;
      this.transportRoutePageNumber = 0;
      this.transportRoutes = [];
      Object.assign(
        this.$data.transportRoutePagination,
        this.$options.data().transportRoutePagination
      );
      this.fetchTransportRouteMembers();
    },

    /**
     * 排出事業者オプション取得アクション
     * @returns {Promise<unknown>}
     */
    fetchTransportRouteMembers() {
      this.transportRouteLoading = true;

      const conditions = {
        query: this.transportRouteSearchKeyword,
        without_invisible: this.withoutInvisible,
        first_trader_owned: this.firstTraderOwned,
        self_emission: this.selfEmission,
        proxy_request: this.proxyRequest,
        general: this.general,
        without_non_reporting: this.withoutNonReporting,
        without_self_emission: this.withoutSelfEmission,
        enable_pagination: true,
      };

      this.fetchTransportRoutes({
        conditions: conditions,
        page: this.transportRoutePageNumber,
      })
        .then((response) => {
          this.transportRoutes = this.transportRoutes.concat(
            response.transport_routes
          );

          this.transportRoutePagination = response.pagination;
          this.transportRoutePageNumber = response.pagination.current_page;
        })
        .finally(() => {
          this.transportRouteLoading = false;
        });
    },

    /**
     * 排出事業者 チェンジイベント
     */
    transportRouteChangeCallback() {
      // this.$emit("update:transport_route_id", this.workableId);
    },

    transportRouteClearCallback() {
      this.workableId = null;
      this.reloadTransportRoutes();
    },

    /**
     * 排出事業者
     * 次ページ読込
     */
    transportRouteInsectCallback() {
      if (this.transportRoutePageNumber > 0) {
        this.transportRoutePageNumber++;
        this.fetchTransportRouteMembers();
      }
    },
    enterKeydownCallback (value) {
      this.transportRoutePageNumber = 0;
      this.transportRouteSearchKeyword = value;
      this.fetchTransportRouteMembers();
    },
    returnCurrentValues() {
      this.$emit("update:values", this.workableId);
    },
  },
};
</script>
<template>
  <div>
    <InfiniteAutocomplete
      v-model="workableId"
      label="ルート"
      :classes="classes"
      :disabled="transportRouteDisabled"
      :loading="transportRouteLoading"
      :members="transportRoutes"
      :pagination="transportRoutePagination"
      :rounded="rounded"
      item-text="label"
      @change="transportRouteChangeCallback"
      @click:clear="transportRouteClearCallback"
      @insect="transportRouteInsectCallback"
      @keydown:enter="enterKeydownCallback"
    >
      <template v-slot:prepend>
        <slot name="prepend" />
      </template>
      <template v-slot:prepend-inner>
        <slot name="prepend-inner" />
      </template>
      <template v-slot:selection="{ item }">
        <slot name="selection" v-bind:item="item">
          {{ item.text }}
        </slot>
      </template>
      <template v-slot:item="{ item }">
        <slot name="item" v-bind:item="item">
          {{ item.label }}
        </slot>
      </template>
      <template v-slot:append>
        <slot name="append" />
      </template>
      <template v-slot:append-outer>
        <slot name="append-outer" />
      </template>
    </InfiniteAutocomplete>
  </div>
</template>
